function IconSimpleArrowRight({ fill, stroke }) {
  return (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 5L4.02899 0.817395C2.69594 0.0175656 1 0.977792 1 2.53238L1 7.46762C1 9.02221 2.69594 9.98243 4.02899 9.1826L11 5Z" fill={fill} stroke={stroke} />
    </svg>
  )
}

export default IconSimpleArrowRight